import { User } from "../stores/user/store";
import Feature from "../stores/user/Feature";
import hasFeature from "../stores/user/actions/hasFeature";
import ROUTES from "./routes";
import { logEventV2 } from "react-migration/lib/util/logEventV2";
import { hasActiveSession, initialiseUser } from "util/user";
import { REDIRECT_OPTIONS } from "./router";

export const logNavigation = (routeName: string, redirectName?: string) => {
  logEventV2({
    name: "Navigation",
    properties: {
      route: routeName.split(/[/?]/)[0],
      redirect: redirectName?.split(/[/?]/)[0],
    },
  });
};

const publicRoutes = [ROUTES.LOGOUT, ROUTES.SHARE];

export const checkUser = async ({
  user,
  routeName = "",
}: {
  user: User;
  routeName?: string | null;
}): Promise<{
  public: boolean;
  authenticated: boolean;
  error: string | null;
  initialisedUser: boolean;
  activeSession?: boolean;
  attemptRedirect?: REDIRECT_OPTIONS;
}> => {
  if (routeName && publicRoutes.includes(routeName)) {
    if (hasFeature(Feature.landInsightAccess)) {
      return {
        public: true,
        authenticated: true,
        error: null,
        activeSession: true,
        initialisedUser: false,
        attemptRedirect: routeName === ROUTES.SHARE ? REDIRECT_OPTIONS.SHARED_SITE : undefined,
      };
    }
    const activeSession = await hasActiveSession();
    if (activeSession && !user?._id) {
      await initialiseUser();
      return {
        public: true,
        authenticated: true,
        error: null,
        activeSession: true,
        initialisedUser: true,
        attemptRedirect: routeName === ROUTES.SHARE ? REDIRECT_OPTIONS.SHARED_SITE : undefined,
      };
    }
    return {
      public: true,
      authenticated: true,
      error: null,
      activeSession: false,
      initialisedUser: false,
    };
  }
  if (!user?._id || !hasFeature(Feature.landInsightAccess)) {
    const initialisedUser = await initialiseUser();
    if (!initialisedUser?._id) {
      return {
        public: false,
        authenticated: false,
        error: null,
        initialisedUser: true,
      };
    }
    if (!initialisedUser.features.includes("landInsightAccess")) {
      return {
        public: false,
        authenticated: false,
        error: "No LandInsight licence for user.",
        initialisedUser: true,
      };
    }
  }
  return {
    public: false,
    authenticated: true,
    error: null,
    initialisedUser: false,
  };
};
